import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { environment } from "src/environments/environment";
import { BannerItem, GetBannerParams } from "../../models/banner-interface";
import { BannerApiService } from "../../services/banner-api.service";
import { TranslateService } from "@ngx-translate/core"; // 1. Import

@Component({
  selector: "app-home-sliderbanner",
  templateUrl: "./home-sliderbanner.component.html",
  styleUrls: ["./home-sliderbanner.component.scss"],
  standalone: false,
})
export class HomeSliderbannerComponent implements OnInit, OnDestroy {
  images: { desktop: string; mobile: string }[] = [];
  bannerItems: BannerItem[] = [];
  resolvedImages: { desktop: string; mobile: string }[] = [];
  index: number = 0;
  loading = false;
  error: string | null = null;

  private sub = new Subscription();

  constructor(
    private bannerApi: BannerApiService,
    private translate: TranslateService // 2. Inject
  ) {}

  ngOnInit(): void {
    this.loadBanners();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  loadBanners(): void {
    this.loading = true;
    this.error = null;
    const params: GetBannerParams = { pageIndex: 0, pageSize: 20 };
    const s = this.bannerApi.fetchBanners(params).subscribe({
      next: (res) => {
        if (res && res.success && res.data && res.data.items) {
          const items: BannerItem[] = [...res.data.items].sort(
            (a, b) => (a.displayPriority ?? Number.MAX_SAFE_INTEGER) - (b.displayPriority ?? Number.MAX_SAFE_INTEGER),
          );
          this.bannerItems = items;
          this.resolvedImages = items
            .map((b) => {
              const getUrl = (url?: string) => {
                if (!url) return "";
                return url.startsWith("/")
                  ? `${environment.imageURL.replace(/\/$/, "")}${url}`
                  : url;
              };
              const desktop = getUrl(b.desktopImageUrl || b.imageUrl || b.desktopImage || b.image || "");
              const mobile = getUrl(b.mobileImageUrl || b.thumbnailUrl || b.mobileImage || b.thumbnail || "") || desktop;
              
              return { desktop, mobile };
            })
            .filter((u) => !!u.desktop || !!u.mobile);
          this.images = this.resolvedImages.slice();
        } else {
          this.images = [];
        }
        this.loading = false;
      },
      error: (err) => {
        console.error(this.translate.instant('home.banner.failed_log'), err);
        this.error = this.translate.instant('home.banner.error_msg'); // 3. Dịch thông báo lỗi
        this.loading = false;
      },
    });
    this.sub.add(s);
  }

  showSlide(i: number) {
    if (i < 0) {
      this.index = this.images.length - 1;
    } else if (i >= this.images.length) {
      this.index = 0;
    } else {
      this.index = i;
    }
  }

  prevSlide() { this.showSlide(this.index - 1); }
  nextSlide() { this.showSlide(this.index + 1); }
}
